import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { CustomerAttributesState } from '../models/customer-attributes.model';
import { UpdateStatedIncomeReq } from '../../profile/models/income.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerAttributesService {
  constructor(private readonly http: HttpClient, private readonly cookieService: CookieService) {}

  getCustomerAttributes() {
    return this.http.get<CustomerAttributesState>(environment.customerAttributes, {
      headers: { Authorization: this.cookieService.get('X-Access-Token') },
    });
  }

  updateStatedIncome(req: UpdateStatedIncomeReq) {
    return this.http.post<any[]>(`${environment.customerGateway}/stated-income`, req, {
      headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
    });
  }
}
